




























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { HsabExpenseResponse } from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import HsabExpenseCardRowPaymentDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPaymentDetail.vue";

@Component({
  components: { HsabExpenseCardRowPaymentDetail }
})
export default class HsabExpenseCardRowPayment extends Vue {
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get hasReimbursement () {
    return this.expense && this.expense.reimbursement;
  }

  get hasOverflowReimbursements () {
    return this.hasReimbursement
        && this.expense.reimbursement.overflowReimbursements
        && this.expense.reimbursement.overflowReimbursements.length > 0;
  }
}
